module.exports = __webpack_public_path__ + "img/22-12_cabrero_thumb.0522e666.jpg";